/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import BannerComponent from "../components/astara/banner.component";
import AstaraComponent from "../components/astara/astara.component";
import CulturaComponent from "../components/astara/cultura.component";
import GoAstaraComponent from "../components/astara/go-astara.component";
import GoHyundaiComponent from "../components/astara/go-hyundai.component";

const AstaraPage: React.FC = () => {
  const [visibleHeight, setVisibleHeight] = useState(0);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Descubre Astara y Hyundai en Colombia - Innovación y Movilidad
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent />
        <AstaraComponent />
        <CulturaComponent />
        <GoAstaraComponent />
        <GoHyundaiComponent />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default AstaraPage;
